import styled from '@themes/theme'

export const EventWrapper = styled.div`
  position:absolute;
  top: 45px;
  left: 0;
  width: 100%;
  height: calc(100% - 45px);
  overflow: auto;
  .event-bg {
    width: 100%;
    height: auto;
    margin-top: -1px;
  }
`
export const ChargingEvent = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  .payment-info-wrap {
    border: 1.5px solid #E1E1E1;
    border-radius: 16px;
    margin: 0 25px;
    padding: 20px 14px 16px 14px;
    text-align: left;
    &:nth-of-type(2) {
      border: none;
      background: #F1F1F2;
      margin-top: 16px;
    }
  }
  .event-tit {
    display: inline-block;
    color: ${props => props.theme.color.mainBg};
    font-size: ${props => props.theme.font.title};
    font-weight: ${props => props.theme.fontW.bold};
    -webkit-text-stroke: .3px ${props => props.theme.color.mainBg};
    text-align: left;
    margin-left: 9px;
    &.my-info {
      position: relative;
      z-index: 1;
      &::before {
        content: '';
        display: block;
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
        width: calc(100% + 4px);
        height: 9px;
        background: #FADA81;
        z-index: -1;
      }
    }
    &:not(&.my-info) {
      display: block;
      border-bottom: 1px solid ${props => props.theme.color.modalSubBg2};
      padding-bottom: 8px;
    }
  }
  .payment-list {
    margin-top: 12px;
    position: relative;
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-between;
    &--item {
      background: #F1F1F2;
      border: 1px solid ${props => props.theme.color.themeTxt};
      width: calc(50% - 5px);
      height: 72px;
      border-radius: 11px;
      display: flex;
      flex-wrap: wrap;
      padding: 12px;
      .txt {
        width: 100%;
        font-size: 11px;
        color: ${props => props.theme.color.modalgray};
        white-space: nowrap;
      }
      .money {
        font-size: ${props => props.theme.font.title};
        font-weight: ${props => props.theme.fontW.bold};
        color: #2E2C33;
        margin-top: 8px;
        &.remainder {
          display: flex;
          align-items: center;
          .remain-payment {
            font-size: ${props => props.theme.font.title};
            font-weight: ${props => props.theme.fontW.bold};
            color: #D0021A;
          }
        }
        .charge-btn {
          width: 39px;
          height: auto;
          margin-left: 4px;
          img {
            width: 100%;
            height: auto;
          }
        }
      }
    }
  }
  .event-list {
    margin-top: 18px;
    padding: 0 6px 0 10px;
    &--item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 19px;
      &:last-child {
        margin-bottom: 6px;
      }
      > p {
        position: relative;
        font-size: 11px;
        color: ${props => props.theme.color.mainBg};
        font-weight: ${props => props.theme.fontW.bold};
        .new-list {
          width: 31px;
          height: auto;
          position: absolute;
          top: -14px;
          left: -12px;
          transform: rotate(-9deg);
        }
      }
      .receive-btn {
        display: inline-flex;
        justify-content: space-between;
        align-items: center;
        .value {
          display: inline-flex;
          justify-content: flex-end;
          align-items: center;
          width: 102px;
          height: 28px;
          padding-right: 9px;
          color: #2e2c33;
          font-size: 14px;
          background: #fff;
          border-radius: 50px;
          svg {
            width: 14px;
            margin-left: 4px;
          }
        }
        .receive-txt, .complete-txt {
          display: inline-flex;
          justify-content: center;
          align-items: center;
          width: 52px;
          height: 28px;
          margin-left: 12px;
          color: #fff;
          background: #d0021a;
          border-radius: 50px;
        }
        .complete-txt {
          display: none;
          background: #c7c7c8;
        }
        // 결제 보상 지급 완료
        &.complete {
          .value {
            color: #e0e0e0;
          }
          .receive-txt {
            display: none;
          }
          .complete-txt {
            display: inline-flex;
          }
        }
      }
    }
  }

`
